import { Dropbox } from 'dropbox'

export const dropbox = new Dropbox({
  accessToken: 'b9-iS6hViEgAAAAAAAAkfMG9OItzANMz0ZHRHHQSVW_cU4AypXskn9UHYUEq_YIN',
  fetch: window.fetch
})
